<script>


export default {
  components: {
    
  }
}
</script>

<template>
  <div>
    

    <section class="main-content  is-fullheight">
		
      <div class=" section pt-1">
        <div class="container">
          <router-view/>
        
        
        </div>
      </div>
		</section>


  </div>

</template>